import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-partys',
  templateUrl: './partys.component.html',
  styleUrls: ['./partys.component.scss']
})
export class PartysComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
